export default "__VITE_ASSET__BKM0I3h6__"